import {
  ClipboardIconButton,
  ClipboardRoot,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverRoot,
  PopoverTitle,
  PopoverTrigger,
} from '@vesyl/ui'
import { Flex, HStack, type PopoverContentProps, type PopoverRootProps } from '@vesyl/ui/chakra'
import { type ReactNode, useState } from 'react'
import { useScrollListener } from '../../hooks/use-scroll-listener'

type ClipboardPopoverProps = {
  title: ReactNode
  content: ReactNode
  clipboardText: string
  rootProps?: PopoverRootProps
  contentProps?: PopoverContentProps
  children: ReactNode
}

export const ClipboardPopover = (props: ClipboardPopoverProps) => {
  const { children, content, clipboardText = '', contentProps, rootProps, title } = props

  const [open, setOpen] = useState(false)

  useScrollListener(() => setOpen(false))

  return (
    <PopoverRoot open={open} onOpenChange={(e) => setOpen(e.open)} lazyMount {...rootProps}>
      <PopoverTrigger as={Flex} asChild>
        {children}
      </PopoverTrigger>
      <PopoverContent {...contentProps}>
        <PopoverArrow />
        <PopoverHeader as={HStack} justifyContent="space-between">
          <PopoverTitle>{title || ''}</PopoverTitle>
          <ClipboardRoot value={clipboardText}>
            <ClipboardIconButton variant="ghost" size="xs" />
          </ClipboardRoot>
        </PopoverHeader>
        <PopoverBody position="relative">{content}</PopoverBody>
      </PopoverContent>
    </PopoverRoot>
  )
}
